import { FieldArray, getIn, useFormikContext } from "formik";
import { useMemo } from "react";
import { IconPlus, IconTrash } from "@tabler/icons-react";
// @ts-expect-error pure js
import { ReactSelect } from "../UI/Select";
// @ts-expect-error pure js
import TextInput from "../UI/TextInput";
import Button from "../UI/Button";
import IconButton from "../UI/IconButton";
import Text from "../UI/Text";
// @ts-expect-error pure js
import useTenants from "../../hooks/use-tenants";
// @ts-expect-error pure js
import { TenantStatus } from "../../models/tenant_old.js";
import type { Tenant } from "../../models/tenant";
import styles from "./RefacturationsFieldArray.module.css";

interface RefacturationsFieldArrayProps {
  name: string;
  propertyId?: number | string;
  disabled?: boolean;
}

export default function RefacturationsFieldArray({
  name,
  propertyId,
  disabled = false,
}: RefacturationsFieldArrayProps) {
  const { tenants } = useTenants();
  const { values } = useFormikContext<Record<string, unknown>>();

  const availableTenants: Tenant[] = useMemo(() => {
    if (!propertyId) return tenants;
    return tenants.filter(
      (tenant: Tenant) => tenant.id_bien === Number(propertyId),
    );
  }, [tenants, propertyId]);

  const refacturationValues: unknown[] = getIn(values, name, []);

  const tenantOptions = useMemo(() => {
    return [
      {
        label: "Locataires actifs",
        options: availableTenants
          .filter((tenant) => tenant.status === TenantStatus.Actif.status)
          .map((tenant) => ({
            label: tenant.nom,
            value: String(tenant.id),
          })),
      },
      {
        label: "Locataires archivés",
        options: availableTenants
          .filter((tenant) => tenant.status === TenantStatus.Archive.status)
          .map((tenant) => ({
            label: tenant.nom,
            value: String(tenant.id),
          })),
      },
    ];
  }, [availableTenants]);

  if (disabled && refacturationValues.length === 0) return null;

  return (
    <div className={styles.wrapper}>
      <Text>
        Si la charge a déjà été refacturée au locataire, indiquez le locataire
        et la date
      </Text>
      <FieldArray
        name={name}
        render={(arrayHelpers) => (
          <>
            {refacturationValues.map((_, index) => (
              <div key={index} className={styles.row}>
                <ReactSelect
                  name={`${name}[${index}].tenant_id`}
                  isDisabled={disabled}
                  options={tenantOptions}
                  placeholder={"Choisissez un locataire"}
                />
                <TextInput
                  type="date"
                  name={`${name}[${index}].date`}
                  label=""
                  marginForm={""}
                  disabled={disabled}
                />
                {!disabled && (
                  <IconButton
                    icon={IconTrash}
                    color="danger"
                    label="Supprimer cette refacturation"
                    onClick={() => arrayHelpers.remove(index)}
                  />
                )}
              </div>
            ))}
            {!disabled && (
              <Button
                type="button"
                variant="tertiary"
                icon={IconPlus}
                onClick={() => arrayHelpers.push({ tenant_id: "", date: "" })}
                className={styles.addButton}
              >
                Ajouter une refacturation
              </Button>
            )}
          </>
        )}
      />
    </div>
  );
}
